import React from 'react';
import { Tag } from 'antd';
import { InfoCircleFilled, WarningFilled } from '@ant-design/icons';

import './style.scss';

export const MyTag = ({
  children,
  status = '',
  className = '',
  type = 'ellipse',
  ...rest
}) => {
  return (
    <Tag className={`my-tag ${status} ${className}`} {...rest}>
      {className.indexOf('warning-tag') > -1 && (
        <span>
          <WarningFilled />
        </span>
      )}
      {className.indexOf('hint-tag') > -1 && (
        <span>
          <InfoCircleFilled />
        </span>
      )}
      {children}
    </Tag>
  );
};

export default MyTag;
